<template>
  <Card class="flex flex-col">
    <CardHeader class="flex flex-col flex-grow">
      <div class="flex justify-between w-full">
        <CardTitle class="flex-grow">{{ title }}</CardTitle>
        <CardAction class="flex justify-end">
          <ToggleInput
            v-if="showToggle"
            :model-value="toggleValue"
            @update:model-value="emit('update:toggle-value', $event)"
          />
        </CardAction>
      </div>
      <CardDescription class="flex-grow">{{ description }}</CardDescription>
    </CardHeader>

    <CardContent>
      <div class="flex justify-between ch-12">
        <TButton v-if="showSettingsButton" color="white" @click="emit('click-settings-button')">Settings</TButton>

        <div v-if="tags.length > 0" class="mt-2 ml-auto flex items-center gap-1">
          <Badge v-if="tags.includes('email')" variant="blue">Email</Badge>
          <Badge v-if="tags.includes('sms')" variant="green">SMS</Badge>
        </div>
      </div>
    </CardContent>
  </Card>
</template>

<script setup lang="ts">
import { Badge } from '@/components/ui/badge';
import { Card, CardAction, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

type WorkflowCardProps = {
  title: string;
  description: string;
  tags: ('email' | 'sms')[];
  toggleValue?: boolean;
  showSettingsButton?: boolean;
  showToggle?: boolean;
};

defineProps<WorkflowCardProps>();

type Emits = {
  'update:toggle-value': [value: boolean];
  'click-settings-button': [];
};
const emit = defineEmits<Emits>();
</script>
